module.exports = __webpack_public_path__ + "media/tycho2t3_80_px.c4725d18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/sky_box/tycho2t3_80_px.jpg
// module id = 1089
// module chunks = 0